'use strict';

var spacer = {};

exports.__exports = spacer;
//# sourceMappingURL=spacer.cjs.map
